/**
 * API response envelope types.
 *
 * The backend wraps all responses in { response: { Items/Item } }.
 * API functions in src/api/ should unwrap these — components never see the envelope.
 */
import type { Package } from './workspace';

export interface ApiListResponse<T> {
  response: {
    Items: T[];
  };
}

export interface ApiItemResponse<T> {
  response: {
    Item: T;
    Packages?: Package[];
    Package?: Package;
  };
}

export class ApiError extends Error {
  status: number;
  body: string;

  constructor(status: number, body: string) {
    super(`API error ${status}: ${body}`);
    this.name = 'ApiError';
    this.status = status;
    this.body = body;
  }
}
